// @ts-nocheck
import { FILES_URL } from "./paths";

export default function documents_treat(docs, sortedBy, reverse_sort, props) {
	let encodeds = [];
	if (docs?.length) {
		encodeds = docs.map((a) => treat_document(a, props));
		if (sortedBy)
			encodeds = encodeds.sort((a, b) => {
				if (a[sortedBy] < b[sortedBy]) return reverse_sort ? 1 : -1;
				return reverse_sort ? -1 : 1;
			});
	}
	return encodeds;
}

export function treat_document(doc, props) {
	// v2 API returns the PK as `id`; legacy v1 used `documentsId` and the
	// rest of the FE (ImageObject, Gallery drag, sendImage payload, doc
	// link/unlink) reads `documentId`. Without aliasing here, dragging a
	// gallery image fires `documents/undefined/file` and the eventual
	// post send arrives at /documents/from-base64 with an empty
	// fileDocString → 400. Alias once at the data-entry boundary.
	const documentId = doc.documentId ?? doc.id ?? doc.documentsId;
	let ret = {
		...doc,
		documentId,
		id: doc.id ?? documentId,
		urlMin: doc.urlMin ? buildUrl(doc.urlMin) : null,
		urlMobile: doc.urlMobile ? buildUrl(doc.urlMobile) : null,
		urlOrigin: doc.urlOrigin ? buildUrl(doc.urlOrigin) : null,
		urlWeb: doc.urlWeb ? buildUrl(doc.urlWeb) : null,
		...props,
	};

	if (!doc.urlMin)
		ret.urlMin = ret.urlMobile ? ret.urlMobile : ret.urlOrigin;
	if (!doc.urlMobile) ret.urlMobile = ret.urlOrigin;
	if (!doc.urlWeb) ret.urlWeb = ret.urlMobile;
	return ret;
}

// Build a usable URL from whatever the API returned. v2 stores relative
// paths (`documents/foo.jpg`) but legacy rows can carry an absolute URL —
// prepending FILES_URL to those would produce
// `…/storage/https%3A//files.onlyall.fr/foo.jpg` and 404 every legacy
// asset. Detect absolute URLs and use them as-is.
function buildUrl(value) {
	const s = String(value);
	if (/^https?:\/\//i.test(s) || s.startsWith("//") || s.startsWith("data:"))
		return s;
	return FILES_URL + encodePath(s.replace(/^\/+/, ""));
}

// Encode each path segment separately so '/' is preserved as a path
// separator. encoding the full string with encodeURIComponent turns
// 'documents/foo.jpg' into 'documents%2Ffoo.jpg', which the API's
// /storage/{*path} route receives as a single segment whose key does
// not match the actual blob key → 404 on every gallery image.
function encodePath(str) {
	return String(str)
		.split("/")
		.map((seg) =>
			encodeURIComponent(seg).replace(/[!'()*]/g, (c) =>
				"%" + c.charCodeAt(0).toString(16),
			),
		)
		.join("/");
}

export function dataURLtoFile(dataurl, filename) {
	if (!dataurl) return false;
	var arr = dataurl.split(",");
	var mime = arr[0].match(/:(.*?);/)[1];
	var bstr = atob(arr[1]);
	var n = bstr.length;
	var u8arr = new Uint8Array(n);

	while (n--) u8arr[n] = bstr.charCodeAt(n);
	return new File([u8arr], filename, {
		type: mime,
	});
}

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes, si = false, dp = 1) {
	const thresh = si ? 1000 : 1024;

	if (Math.abs(bytes) < thresh) return bytes + " B";

	const units = si
		? ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
		: ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
	let u = -1;
	const r = 10 ** dp;

	do {
		bytes /= thresh;
		++u;
	} while (
		Math.round(Math.abs(bytes) * r) / r >= thresh &&
		u < units.length - 1
	);
	return bytes.toFixed(dp) + " " + units[u];
}
